module.exports = __webpack_public_path__ + "static/media/man_xiaoguang.7f0147bf.png";